<template>
  <b-modal
    ref="removeDataModal"
    hide-footer
    centered
    title="Remove data by path"
    size="sm"
    >
    <b-form @submit.prevent="remove">
      <b-form-group
        label="Path to data:"
        >
        <b-form-input
          type="text"
          v-model.trim="pathToData"
          autocomplete="off"
          />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
// source
import db from '@/services/db'

let $ = window.$

export default {
  props: ['eventBus'],
  data () {
    return {
      pathToData: ''
    }
  },
  methods: {
    remove () {
      db.root.ref(this.pathToData).remove()
      if (this.$refs.removeDataModal) this.$refs.removeDataModal.hide()
    }
  },
  created () {
    this.eventBus.$on('showRemoveDataModal', () => {
      if (this.$refs.removeDataModal) this.$refs.removeDataModal.show()
    })
  },
  mounted () {
    if (this.$refs.removeDataModal) {
      $(this.$refs.removeDataModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.removeDataModal) {
      $(this.$refs.removeDataModal['$el']).remove()
    }
  }
}
</script>
